import React from 'react';
import { FieldError } from 'react-hook-form';
import CheckIcon from 'assets/img/svg/check.svg';
import FileDownload from 'assets/img/svg/download.svg';
import classes from '../Button/styles.module.scss';
import cn from 'classnames';

export default function File({
	onChange,
	size = 'md',
	error,
	name,
	label = 'Выберите файл',
	nowrap = false,
	classNameBtn,
	labelClass,
	buttonText = 'Выберите файл',
	multiple = false,
	noWrapLabel = false,
	id = 'file',
}: {
	name: string;
	onChange: (...event: any[]) => void;
	size?: 'md' | 'sm' | 'lg';
	error?: FieldError;
	label?: string | null;
	nowrap?: boolean;
	classNameBtn?: string;
	labelClass?: string;
	buttonText?: string | null;
	multiple?: boolean;
	noWrapLabel?: boolean;
	id?: string;
}) {
	const [filename, setFilename] = React.useState(buttonText);

	const handleChange = (e: any) => {
		if (e?.target?.files?.[0]) {
			setFilename(e.target.files[0]?.name);
		}
		onChange(e.target.files);
	};

	return (
		<label htmlFor={id} className={labelClass && classes['input-file']}>
			{label && (
				<span className={cn(classes.label__title, { [classes['label__title_no-wrap']]: noWrapLabel })}>{label}</span>
			)}
			<input id={id} type="file" name={name} onChange={handleChange} hidden multiple={multiple} />
			<div
				className={cn(
					classes.btn,
					classes[`btn--${size}`],
					classes[`btn-primery`],
					{ [classes[`btn-nowrap`]]: nowrap && filename !== 'Выберите файл' }
				)}
			>
				<i>
					<img
						src={filename && filename !== 'Выберите файл' ? CheckIcon : FileDownload}
						alt=""
						style={{ filter: 'brightness(0) invert(1)' }}
					/>
				</i>
				{buttonText && <span>{filename}</span>}
			</div>
			{error && <small className={classes[`input-file__error`]}>{error.message}</small>}
		</label>
	);
}
